export const labelCss = (status) => {
  switch (status) {
    case 'adjusting':
      return { class: 'bg-gray-100 text-gray-600', name: '調整中' }
    case 'fixed':
      return { class: 'bg-blue-100 text-blue-600', name: '調整済み' }
    case 'waiting':
      return { class: 'bg-red-100 text-red-600', name: '承認待ち' }
    case 'approval':
      return { class: 'bg-green-100 text-green-600', name: '承認済み' }
    default:
      return { class: '', name: '' }
  }
}
